import React, { useEffect } from 'react'
import MasterLayout from "../../masterLayout/MasterLayout";
import Loader from "../../components/Loader";
import FormPromociones from "../../components/promociones/FormPromociones";
import usePromocionesStore from "../../store/promocionesStore";
import { useNavigate, useParams } from "react-router-dom";

const DetallePromocion = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { isLoading, iniciar, setNavigate, actualizarId } = usePromocionesStore();
  
  useEffect(() => {
    setNavigate(navigate);
    actualizarId(id);
    iniciar();
  }, []);
  
  return (
    <>
      <MasterLayout>
        { isLoading ? <Loader /> : <FormPromociones/> }
      </MasterLayout>
    </>
  )
}

export default DetallePromocion
